export const twitterQuery = /* groq */ `
_type,
site,
cardType,
handle
`
